/**
 * Flow Optimizer — Default config factory
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FlowOptimizerConfig } from '@trafficpulse/shared';

export function buildDefaultConfig(
  campaignId: string,
  flowId: string,
): FlowOptimizerConfig {
  return {
    campaignId,
    flowId,
    mode: 'STANDARD',
    enabled: false,
    killSwitch: false,
    intervalMin: 60,
    minWeight: 1,
    maxWeight: 95,
    standardJson: {},
    excludeRules: { paths: null, landers: null, offers: null },
    formula: { groups: [], groupWeights: {} },
    capacityRules: [],
    lastRunAt: null,
    lastRunOk: null,
    lastError: null,
  };
}
